import styled from 'styled-components';
import { Image, inlineMediaQueryMixin } from '@zillow/constellation';

var GroupBackgroundImage = /*#__PURE__*/styled(Image).withConfig({
  componentId: "sc-19vtin-0"
})(["&&&{pointer-events:none;position:absolute;top:0;right:0;bottom:0;left:0;", " width:100%;height:100%;", " ", "}"], inlineMediaQueryMixin('backgroundSize', function (mediaProps) {
  return "object-fit: " + mediaProps.backgroundSize + ";";
}), inlineMediaQueryMixin('backgroundPosition', function (mediaProps) {
  return "object-position: " + mediaProps.backgroundPosition + ";";
}), inlineMediaQueryMixin('backgroundImageVisible', function (mediaProps) {
  return mediaProps.backgroundImageVisible ? 'display: initial;' : 'display: none;';
}));
GroupBackgroundImage.defaultProps = {
  backgroundPosition: '50% 50%',
  backgroundSize: {
    default: 'cover'
  }
};
var GroupBackgroundImage$1 = GroupBackgroundImage;

export { GroupBackgroundImage$1 as default };
